import axiosInstance from "../utils/axios";

export const vocationalInstitutionOwnershipService = {
  fetchAllWithoutPaginate: async () => {
    const response = await axiosInstance.get("/institutional-ownership/all");
    return response.data;
  },
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get("/institutional-ownership", {
      params,
    });
    return response.data;
  },
  findById: async (id) => {
    const response = await axiosInstance.get("/institutional-ownership/" + id);
    return response.data;
  },
  store: async (data) => {
    const response = await axiosInstance.post("/institutional-ownership", data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await axiosInstance.put(
      `/institutional-ownership/${id}`,
      data
    );
    return response.data;
  },
  delete: async (id) => {
    const response = await axiosInstance.delete(
      `/institutional-ownership/${id}`
    );
    return response.data;
  },
};
